// services/cartService.js

import API from "../../../../app/api";

export const addToCartService = async (product_id, quantity) => {
    const response = await API.post("/cart/add-to-cart", {
        product_id,
        quantity,
    });

    return response.data;
};